<template>
  <div v-if="show" :class="['col-xs-12', `col-md-${size}`]">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "c-protocolo-dupla-tcc",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapState({ isDupla: state => state.atendimento.isDupla })
  },
  asyncComputed: {
    verificar() {
      if (this.isDupla == true) {
        this.show = true;
      } else {
        this.$emit("input", '');
        this.show = false;
      }
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/DuplaTcc.vue